import { render, staticRenderFns } from "./MediaServer.vue?vue&type=template&id=5e887a0a&scoped=true&"
import script from "./MediaServer.vue?vue&type=script&lang=js&"
export * from "./MediaServer.vue?vue&type=script&lang=js&"
import style0 from "./MediaServer.vue?vue&type=style&index=0&id=5e887a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e887a0a",
  null
  
)

export default component.exports